import {css} from 'styled-components';

/*
 * Constants.
 */

export const createFormInputFieldHeight = 30; // px.

export const createFormFieldHoverStyle = css`
  &:hover {
    background: ${(p) => p.theme.greys.shade30};
  }
`;
